import { chakra, shouldForwardProp, Text } from "@chakra-ui/react";
import {
  isValidMotionProp,
  motion,
  useSpring,
  useTransform,
} from "framer-motion";
import React from "react";
import {
  special2TextGradientStyle,
  specialTextGradientStyle,
} from "../../../utils/specialTextGradientStyle";

const ChakraBox = chakra(motion.p, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});
const gradientStyle = {
  background:
    "linear-gradient(180deg, rgba(2,0,36,1) 0%, rgba(247,249,79,1) 0%, rgba(254,238,54,1) 50%, rgba(245,174,12,1) 75%, rgba(236,208,59,1) 100%)",
  WebkitBackgroundClip: "text",
  backgroundClip: "text",
  color: "transparent",
  //   display: "inline-block",
};

const JackpotNumber = ({
  place,
  number,
  mv,
  isLastNumber,
  fontSize,
  inset,
}) => {
  const intPlace = useTransform(
    mv,
    (latest) => Math.floor(latest / place) % 10
  );

  const springPlace = useSpring(intPlace, {
    stiffness: 200,
    damping: 60,
  });

  const y = useTransform(isLastNumber ? mv : springPlace, (val) => {
    // isLastNumber為最後一位數字才會有動畫
    const height = 30;

    const placeValue = isLastNumber ? (val / place) % 10 : val;

    let offset = (10 + number - placeValue) % 10;
    let memo = offset * height;
    if (offset > 5) memo -= 10 * height;
    return memo;
  });

  return (
    <ChakraBox
      style={{ y }}
      position={"absolute"}
      inset={
        inset || {
          base: "-12px 0px 0px 0px",
          md: "-10px 0px 0px 0px",
        }
      }
      display={"flex"}
      justifyContent={"center"}
      sx={special2TextGradientStyle}
      color={"transparent"}
      fontWeight={900}
      fontSize={
        fontSize || {
          base: "20px",
          md: "26px",
        }
      }
    >
      {number}
    </ChakraBox>
  );
};

export default JackpotNumber;
